import { useEffect } from "react";
import { shareBigThree, loadFaces } from "./bigThreeCard";
import { ShareCardButton } from "./ShareCardButton";

/* "Share my Big Three": the story card from bigThreeCard.js. The card's
   faces load on mount, so a tap goes straight to the share sheet. */
export function ShareBigThree({ natal, birthData, tiles = [], style }) {
  useEffect(() => { loadFaces(); }, []);
  const seed = birthData.birthDate.year * 400 + birthData.birthDate.month * 31 + birthData.birthDate.day;
  return <ShareCardButton make={() => shareBigThree({ natal, birthSeed: seed, tiles })} label="Share my Big Three" style={style} />;
}
